import type { Node as ProseMirrorNode } from '@tiptap/pm/model'
import {
  imageUploadContainer,
  imageUploadError,
  imageUploadImage,
  imageUploadProgressBar,
  imageUploadProgressText,
  imageUploadRemoveButton
} from './ImageUploadNodeView.css'

type ImageUploadNodeViewProps = {
  node: ProseMirrorNode
  onRemove: () => void
}

export const ImageUploadNodeView = ({
  node,
  onRemove
}: ImageUploadNodeViewProps) => {
  const src: string = node.attrs.src ?? ''
  const progress: number = node.attrs.uploadProgress ?? 0
  const error: string | null = node.attrs.uploadError ?? null

  if (error) {
    return (
      <div className={imageUploadContainer}>
        <img src={src} alt="" className={imageUploadImage} />
        <div className={imageUploadError}>
          {error}
          <button
            type="button"
            className={imageUploadRemoveButton}
            onClick={onRemove}
          >
            Retirer l'image
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className={imageUploadContainer}>
      <img src={src} alt="" className={imageUploadImage} />
      <span className={imageUploadProgressText}>{progress}%</span>
      <div className={imageUploadProgressBar} data-progress={progress} />
    </div>
  )
}
